// extracted by mini-css-extract-plugin
module.exports = {"flags":"FlagsRenderer_flags__RZ1x_"};